"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputFiles = {
  image: {
    inputType: '.png,.jpeg,image/jpeg,image/png',
    validType: ['image/jpeg', 'image/png'],
    signatures: ['89504E47', 'FFD8FFDB', 'FFD8FFE0', 'FFD8FFE1']
  },
  pdf: {
    inputType: '.pdf,application/pdf',
    validType: ['application/pdf'],
    signatures: ['25504446']
  }
};